import createIcon from '../../createIcon';

/**
 * @component @name PersonPinCircle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM4LjE0IDIgNSA1LjE0IDUgOUM1IDE0LjI1IDEyIDIyIDEyIDIyQzEyIDIyIDE5IDE0LjI1IDE5IDlDMTkgNS4xNCAxNS44NiAyIDEyIDJaTTEyIDRDMTMuMSA0IDE0IDQuOSAxNCA2QzE0IDcuMTEgMTMuMSA4IDEyIDhDMTAuOSA4IDEwIDcuMTEgMTAgNkMxMCA0LjkgMTAuOSA0IDEyIDRaTTEyIDE0QzEwLjMzIDE0IDguODYgMTMuMTUgOCAxMS44NUM4LjAyIDEwLjUzIDEwLjY3IDkuOCAxMiA5LjhDMTMuMzMgOS44IDE1Ljk4IDEwLjUzIDE2IDExLjg1QzE1LjE0IDEzLjE1IDEzLjY3IDE0IDEyIDE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PersonPinCircle = createIcon('PersonPinCircle', [
  [
    'path',
    {
      d: 'M12 2C8.14 2 5 5.14 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.14 15.86 2 12 2ZM12 4C13.1 4 14 4.9 14 6C14 7.11 13.1 8 12 8C10.9 8 10 7.11 10 6C10 4.9 10.9 4 12 4ZM12 14C10.33 14 8.86 13.15 8 11.85C8.02 10.53 10.67 9.8 12 9.8C13.33 9.8 15.98 10.53 16 11.85C15.14 13.15 13.67 14 12 14Z',
      key: 'v0ibz2',
    },
  ],
]);

export default PersonPinCircle;
